import { render, staticRenderFns } from "./RuleInterval.vue?vue&type=template&id=685641e1"
import script from "./RuleInterval.vue?vue&type=script&lang=js"
export * from "./RuleInterval.vue?vue&type=script&lang=js"
import style0 from "./RuleInterval.vue?vue&type=style&index=0&id=685641e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports